<template>
  <div :class="$style['pt-integral-task']" v-loading="loading">
    <pt-page-title title="积分任务">
    </pt-page-title>
    <pt-page-factor-filter :labels="filterItems" v-model="filterCondition"  isQueryRouter @Filter="Filter" ref="filter">
      <template>
        <el-button type="primary" @click="Filter()">统计</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <p :class="$style['summary-tip']">
      <span>发放积分总计：</span>
      {{pointSummay}}
    </p>
    <pt-integral-task-list :tableLabel="tableLabels" :params-data="paramsData" ref="tableWithData"  :isFromRouter="isFromRouter" :isSearch="isSearch" @updateSummay="(val)=>pointSummay = val">
      <el-table-column label="操作">
        <div :class="$style['opreation-button']" slot-scope="scope">
          <i class="iconfont icon-xiangqing" @click="goDetail(scope.row)"></i>
          <i class="iconfont icon-bianji"  @click="editItem(scope.row)"></i>
        </div>
      </el-table-column>
    </pt-integral-task-list>
  </div>
</template>

<script>
import ptIntegralTaskList from './pt-integral-task-list/withData'
import { tableLabels, filterItems } from './integral-task.js'
import { emptyObject } from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-integral-task'

export default {
  name: 'pt-integral-task',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptIntegralTaskList
  },
  data () {
    return {
      filterItems: filterItems,
      tableLabels: tableLabels,
      filterCondition: {
        publishTime: this.getMounthLoginTime()
      },
      paramsData: {
        publishTime: this.getMounthLoginTime()
      },
      isFromRouter: true,
      searchKey: null,
      loading: false,
      isSearch: false,
      pointSummay: '--'
    }
  },
  watch: {

  },
  methods: {
    cleanParams () {
      emptyObject(this.filterCondition)
      this.Filter()
    },
    emptySearch () {
      this.searchKey = null
      this.paramsData.searchKey = null
    },
    search (val) {
      this.isFromRouter = false
      this.searchKey = val
      this.isSearch = true
      this.$set(this.paramsData, 'searchKey', val)
    },
    Filter (isFromRouter) {
      this.isSearch = false
      this.isFromRouter = isFromRouter
      for (let key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCondition)
      }
      this.paramsData = { ...this.filterCondition }
    },
    editItem (row) {
      this.$router.push(`/integral-task-form/true/${row.pointsTask.id}`)
    },
    goDetail (row) {
      this.$router.push(`/integral-task-detail/${row.pointsTask.id}`)
    },
    // 默认筛选登录时间为最近一个月
    getMounthLoginTime () {
      let nowDate = new Date().getTime()
      // 当前时间的一个月前的零点
      let startTime = new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 3600 * 1000
      let loginTimeSelct = {
        startDate: startTime,
        endDate: nowDate
      }
      return loginTimeSelct
    }
  },
  created () {
    this.$nextTick(_ => {
      this.paramsData = this.filterCondition = { publishTime: this.getMounthLoginTime() }
    })
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.pt-integral-task{
  .summary-tip{
    text-align: right;
    font-size: 30px;
    color:#606266;
    span{
      font-size: 20px;
      color:@mainColor;
      font-weight: 800;
    }
  }
}
.opreation-button{
    :global
    .iconfont{
        margin-right: 10px;
    }
}
</style>
